<section class="main-section">
  <app-loader></app-loader>

  <app-my-nav-template-version-v1></app-my-nav-template-version-v1>
  <!-- Body Content end -->

</section>
<!-- <p style="z-index: 99999;position: sticky;bottom: 2%;">Copyright © {{'2024'}} Flowsmart.</p> -->